import React from 'react';

import appConfig from 'appConfig';
import { CardStack } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { FormattedMessage } from 'react-intl';
import manifestShape from 'Workspace/types/pluginManifest';
import messages from './messages';

import {
  SchemaBlock,
} from './styles';

const PluginSchemaCard = ({ manifest }) => (
  <CardStack
    icon="schema"
    title={intl.formatMessage(messages.pluginSchemaTitle)}
    description={(
      <FormattedMessage
        {...messages.pluginSchemaDescription}
        values={{
          version: manifest.version,
          developerDocsLink: <a href={`${appConfig.getDeveloperDocsURL()}/plugins/schemas/overview`}>{intl.formatMessage(messages.developerDocsLink)}</a>,
        }}
      />
    )}
  >
    <SchemaBlock>
      { JSON.stringify(JSON.parse(manifest.configurationSchema), null, 2) }
    </SchemaBlock>
  </CardStack>
);

PluginSchemaCard.propTypes = {
  manifest: manifestShape,
};

export default PluginSchemaCard;
